import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react-router';

import FaqWithQuery, { type FaqIndexProps } from '@cx-modules/faq';

export const Faq = (props: Omit<FaqIndexProps, 'i18n'>) => {
  const { i18n } = useTranslation();
  return (
    <ErrorBoundary fallbackRender={() => null} onError={error => captureException(error)}>
      <FaqWithQuery {...props} i18n={i18n} />
    </ErrorBoundary>
  );
};
